/**
 * Site-wide summer sale configuration.
 * The customer enters the promotion code manually in Shopify checkout.
 * Checkout creation must remain independent from promotion availability.
 */
export const SUMMER_SALE = {
  active: false,
  percent: 25,
  code: "SUMMER25",
} as const;

export const salePercent = SUMMER_SALE.active ? SUMMER_SALE.percent : 0;

/** Returns the discounted amount for a given original price. */
export function salePrice(amount: number | string): number {
  const value = typeof amount === "string" ? parseFloat(amount) : amount;
  if (!isFinite(value)) return 0;
  if (!SUMMER_SALE.active) return value;
  return Math.round(value * (1 - SUMMER_SALE.percent / 100) * 100) / 100;
}

export const saleLabels: Record<string, { banner: string; badge: string; auto: string }> = {
  fr: {
    banner: "SOLDES D'ÉTÉ : -25% sur tout le site, entrez le code au paiement Shopify",
    badge: "-25%",
    auto: "Entrez le code au paiement Shopify",
  },
  en: {
    banner: "SUMMER SALE: 25% off everything, enter the code at Shopify checkout",
    badge: "-25%",
    auto: "Enter the code at Shopify checkout",
  },
  nl: {
    banner: "ZOMERSALE: 25% korting op alles, voer de code in bij Shopify Checkout",
    badge: "-25%",
    auto: "Voer de code in bij Shopify Checkout",
  },
  pl: {
    banner: "LETNIA WYPRZEDAŻ: -25% na wszystko, wpisz kod przy płatności Shopify",
    badge: "-25%",
    auto: "Wpisz kod przy płatności Shopify",
  },
  ro: {
    banner: "REDUCERI DE VARĂ: -25% la tot, introdu codul la plata Shopify",
    badge: "-25%",
    auto: "Introdu codul la plata Shopify",
  },
};